import * as React from "react";
//import ReactDOM from "react-dom/client";
//import { StyledEngineProvider } from "@mui/material/styles";
import Demo from "../../../componentes/generaStepper/HorizontalLinearStepper";

import Stepper1 from "../../../componentes/generaStepper/Stepper1";
import Stepper2 from "../../../componentes/generaStepper/Stepper2";

//npm install react react-dom
//npm install @emotion/react
//npm install @emotion/styled
//npm i styled-components
//npm i @mui/styled-engine
//npm i @emotion/react @emotion/styled
//npm install @emotion/react --save
export default function Stepper() {
  return (
    <div className="container container-Vista">
        
          <React.StrictMode>
            {/* <StyledEngineProvider injectFirst> */}
            <h1>Stepper 1</h1>
            <div className="container-Componente" >
              <br/>
              <Demo />
              <br/>
            </div>
            <h1>Stepper 2</h1>
            <div className="container-Componente" >
              <br/>
              <Stepper1 />
              <br/>
            </div>
           
            <h1>Stepper 3</h1>
            <div className="container-Componente" >
              <br/>
              <Stepper2 />
              <br/>
            </div>
          
          </React.StrictMode>
          ;
    
    </div>
  );
}
